(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["list-collections-template"]) return;
  try {
    
  function initBrandDirectories(scope) {
    scope.querySelectorAll('[data-vb-brands]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('[data-vb-search]');
      const cards = Array.from(root.querySelectorAll('[data-vb-brand]'));
      const categoryCards = Array.from(root.querySelectorAll('[data-vb-category]'));
      const directory = root.querySelector('[data-vb-directory]');
      const results = root.querySelector('[data-vb-results]');
      const clear = root.querySelector('[data-vb-clear]');
      const empty = root.querySelector('[data-vb-empty]');
      const heading = root.querySelector('[data-vb-category-title]');
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
      const entries = cards.map(card => [card, normalize(card.dataset.vbBrand)]);
      let category = '';
      function filter() {
        const query = normalize(input.value);
        let count = 0;
        entries.forEach(([card, name]) => {
          card.hidden = !card.dataset.vbCategories.split(',').includes(category) || !name.includes(query);
          if (!card.hidden) count += 1;
        });
        results.textContent = count + ' ' + (count === 1 ? results.dataset.one : results.dataset.suffix);
        clear.hidden = !input.value;
        empty.hidden = count > 0;
      }
      function selectCategory(value, focus) {
        const chosen = categoryCards.find(card => card.dataset.vbCategory === value);
        category = chosen ? value : '';
        directory.hidden = !category;
        input.value = '';
        categoryCards.forEach(card => {
          if (card === chosen) card.setAttribute('aria-current', 'true');
          else card.removeAttribute('aria-current');
        });
        if (chosen) {
          heading.textContent = chosen.dataset.label;
          cards.forEach(card => {
            const photo = card.querySelector('template[data-vb-category-photo="' + category + '"]');
            if (photo) card.querySelector('.vb-brands__photo').replaceChildren(photo.content.cloneNode(true));
            card.href = card.dataset.vbUrl + '?view=vb-' + category;
            card.querySelector('[data-vb-explore]').textContent = chosen.dataset.explore;
          });
          filter();
          if (focus) {
            directory.scrollIntoView({ block: 'start' });
            heading.focus({ preventScroll: true });
          }
        }
      }
      categoryCards.forEach(card => {
        card.href = window.location.pathname + '#' + card.dataset.vbCategory;
        card.addEventListener('click', event => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          history.pushState(null, '', card.href);
          selectCategory(card.dataset.vbCategory, true);
        });
      });
      input.addEventListener('input', filter);
      clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
      root.querySelector('[data-vb-back]').addEventListener('click', () => {
        history.pushState(null, '', window.location.pathname);
        selectCategory('', false);
        categoryCards[0].focus();
      });
      window.addEventListener('hashchange', () => selectCategory(location.hash.slice(1), false));
      window.addEventListener('popstate', () => selectCategory(location.hash.slice(1), false));
      root.querySelector('[data-vb-tools]').hidden = false;
      selectCategory(location.hash.slice(1), false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBrandDirectories(document), { once: true });
  else initBrandDirectories(document);
  document.addEventListener('shopify:section:load', event => initBrandDirectories(event.target.parentNode));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vb-brand-category"]) return;
  try {
    
  async function initBrandCategoryProducts(scope) {
    const roots = scope.querySelectorAll('[data-vb-category-products]');
    for (const root of roots) {
      if (root.dataset.ready) continue;
      root.dataset.ready = 'true';
      const grid = root.querySelector('[data-vb-product-grid]');
      const status = root.querySelector('[data-vb-product-status]');
      const pager = root.querySelector('[data-vb-product-pager]');
      const nativePager = root.querySelector('[data-vb-native-pager]');
      const previous = root.querySelector('[data-vb-prev]');
      const next = root.querySelector('[data-vb-next]');
      let cards = Array.from(grid.children);
      let page = 1;
      const perPage = 24;
      function displayPage() {
        cards.forEach((card, index) => { card.hidden = index < (page - 1) * perPage || index >= page * perPage; });
        const totalPages = Math.max(1, Math.ceil(cards.length / perPage));
        previous.disabled = page <= 1;
        next.disabled = page >= totalPages;
        root.querySelector('[data-vb-page-number]').textContent = root.dataset.pageLabel + ' ' + page + ' / ' + totalPages;
      }
      displayPage();
      try {
        const pages = Number(root.dataset.pages) || 1;
        const current = Number(root.dataset.current) || 1;
        const pageNumbers = Array.from({ length: pages }, (_, i) => i + 1).filter(number => number !== current);
        const responses = await Promise.all(pageNumbers.map(async number => {
          const url = new URL(window.location.href);
          url.searchParams.set('page', String(number));
          url.searchParams.set('section_id', 'vb-brand-category');
          const response = await fetch(url.toString(), { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Category page could not load');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = doc.querySelector('[data-vb-product-grid]');
          if (!incoming) throw new Error('Category grid missing');
          return { page: number, cards: Array.from(incoming.children) };
        }));
        const allPages = [...responses, { page: current, cards }].sort((a, b) => a.page - b.page);
        cards = allPages.flatMap(result => result.cards);
        const seen = new Set();
        cards = cards.filter(card => {
          const key = card.getAttribute('href');
          if (seen.has(key)) return false;
          seen.add(key);
          return true;
        });
        grid.replaceChildren(...cards);
        nativePager.hidden = true;
        pager.hidden = cards.length <= perPage;
        status.textContent = cards.length ? cards.length + ' ' + root.dataset.productsLabel : root.dataset.empty;
        displayPage();
      } catch {
        cards.forEach(card => { card.hidden = false; });
        status.textContent = root.dataset.failed;
      }
      previous.addEventListener('click', () => { page -= 1; displayPage(); root.scrollIntoView({ block: 'start' }); });
      next.addEventListener('click', () => { page += 1; displayPage(); root.scrollIntoView({ block: 'start' }); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initBrandCategoryProducts(document), { once: true });
  else initBrandCategoryProducts(document);
  document.addEventListener('shopify:section:load', event => initBrandCategoryProducts(event.target.parentNode));

  } catch(e) { console.error(e); }
})();
})();
